export default __webpack_public_path__ + "static/media/43t.4f9834b4.jpg";